import React, { useState, useRef } from "react";

import { RightMinimalArrow } from "icons";

import dsdeApi from "apis/dsde";
import dsdesExploreApi from "apis/dsdesExplore";
import {
  Button,
  Pane,
  Steps,
  Toastr,
  Typography,
} from "clearsense-ui/components";

import CreateSource from "./CreateSource";
import CreateValues from "./CreateValues";

const CreateReferenceSource = ({
  isPaneOpen,
  setIsPaneOpen,
  dataSource,
  cde,
  fetchAssociatedReferenceSource,
}) => {
  const [currentStep, setCurrentStep] = useState(1);
  const [referenceSource, setReferenceSource] = useState([]);
  const [values, setValues] = useState([]);
  const formRef = useRef();

  const resetForm = async () => {
    setReferenceSource([]);
    setValues([]);
    setIsPaneOpen(false);
    setCurrentStep(1);
  };

  const saveValues = async () => {
    if (values.length > 0) {
      try {
        const dsde = await dsdeApi.show({
          cde_definition_id: cde?.id,
          data_source_id: dataSource?.id,
        });
        if (dsde.status === 204) {
          Toastr.info("Please associate a DSDE before continuing.");
          return "";
        }
        await dsdesExploreApi.createReferenceSources(dsde?.data?.dsde?.id, {
          ...referenceSource,
          reference_source_values_attributes: values,
        });
        fetchAssociatedReferenceSource();
        resetForm();
      } catch (error) {
        logger.log(error);
      }
    } else {
      Toastr.error("Please add at least one value before saving");
    }

    return "";
  };

  return (
    <Pane isOpen={isPaneOpen} onClose={() => setIsPaneOpen(false)} size="md">
      <Pane.Header>
        <Typography style="h3" type="bold" className="-mt-3">
          Create Reference Source Associated to DSDE{" "}
        </Typography>
        <Typography style="large">
          Manually create a reference source associated to this DSDE
        </Typography>
      </Pane.Header>
      <Pane.Body className="py-8">
        <Steps
          steps={["Create Source", "Create Values"]}
          currentStep={currentStep}
          setCurrentStep={setCurrentStep}
          className="mb-4"
        />
        {currentStep === 1 ? (
          <CreateSource
            formRef={formRef}
            setCurrentStep={setCurrentStep}
            setReferenceSource={setReferenceSource}
            dataSource={dataSource}
            cde={cde}
          />
        ) : (
          <CreateValues
            values={values}
            setValues={setValues}
            referenceSource={referenceSource}
          />
        )}
      </Pane.Body>
      <Pane.Footer className="items-center z-50 gap-2">
        {currentStep === 1 ? (
          <div className="flex items-center gap-2 w-full justify-end">
            <Button
              style="secondary"
              label="Cancel"
              onClick={() => setIsPaneOpen(false)}
            />
            <Button
              label="Next"
              icon={RightMinimalArrow}
              iconPosition="right"
              onClick={() => formRef.current.submitForm()}
            />
          </div>
        ) : (
          <>
            <Button label="Save and Close" onClick={saveValues} />
            <Button style="secondary" label="Cancel" onClick={resetForm} />
          </>
        )}
      </Pane.Footer>
    </Pane>
  );
};

export default CreateReferenceSource;
